<script lang="ts">
	import { page } from '$app/stores';
	import { PUBLIC_IMAGES_API } from '$env/static/public';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import __ from '$lib/stores/TranslationStore';
	import { language } from '$lib/translations';
	import { toWebp } from '$lib/utils/helpers/convert';

	// TODO: use slots for customization instead of arbitraty props.
	export let article: IndexArticle | Article;
	export let compact: boolean = false;
	export let withoutCover: boolean = false;
	export let light: boolean = false;
	export let customCoverClass: string = '';
	let className: string = '';
	export { className as class };
	export let headerClass: string = '';
	export let titleClass: string = '';
	export let labelClass: string = '';
	export let descriptionClass: string = '';
	export let footerClass: string = '';
	export let imageLoading: 'lazy' | 'eager' | null = 'lazy';

	const url = PUBLIC_IMAGES_API;
</script>

<a
	class={className || ''}
	href={`${$page.data?.location?.origin}/artigos/${article.category.main?.slug}/${article.slug}`}
	data-sveltekit-preload-data="off"
>
	<article
		class={`flex h-full w-full flex-1 flex-col justify-between space-y-5 text-${
			light ? 'light' : 'dark'
		}`}
	>
		<header class={headerClass || 'flex flex-col space-y-5'}>
			{#if !withoutCover}
				{@const filename = toWebp(article.cover_name)}
				<figure class={`flex justify-center ${customCoverClass}`}>
					<img
						loading={imageLoading}
						class="aspect-[14/9] w-full object-cover"
						src="{url}/900/{filename}"
						role="presentation"
						srcset="
							{url}/200/{filename} 200w,
							{url}/300/{filename} 300w,
							{url}/400/{filename} 400w,
							{url}/800/{filename} 800w,
							{url}/900/{filename} 900w
						"
						sizes="
							(max-width: 640px) 200px,
							(max-width: 768px) 300px,
							(max-width: 1024px) 400px,
							(max-width: 1280px) 800px,
							(max-width: 1536px) 900px,
							900px
						"
						alt={article.cover_alt || article.title}
					/>
					<!-- <ImageRes
						resolveSizeUrl={(_, baseName, ext, size) => `${url}/${size}/${baseName}.${ext}`}
					/> -->
				</figure>
			{/if}
			<div class="flex flex-col space-y-2">
				<div class={labelClass || 'text-sm font-semibold uppercase text-primary'}>
					{article.category.label}
				</div>
				<h2 class={titleClass || 'line-clamp-2 text-xl'}>{article.title}</h2>
				{#if !compact}
					<p
						class={descriptionClass ||
							'line-clamp-4 overflow-hidden text-ellipsis text-justify text-sm'}
					>
						{article.introduction_text}
					</p>
				{/if}
			</div>
		</header>
		<slot name="footer" {article}>
			<footer class={footerClass || 'mt-auto'}>
				<p class="text-xs">
					<span class="published_at">{article.published_at}</span> •
					<span class="read_duration">{article.read_duration} min</span>
				</p>
			</footer>
		</slot>
	</article>
</a>
